import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { APP_ORIGIN, SEO } from '../../config/seo';

// Keeps <title>, description, canonical, robots and share tags in step with
// the route. Public pages (config/seo.js) are indexable; everything else is
// signed-in space and gets noindex.
const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export default function SeoManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
    const page = SEO[path];
    if (!page) {
      setMeta('name', 'robots', 'noindex, nofollow');
      return;
    }
    const url = `${APP_ORIGIN}${page.canonical || path}`;
    document.title = page.title;
    setMeta('name', 'robots', 'index, follow');
    setMeta('name', 'description', page.description);
    setMeta('property', 'og:title', page.title);
    setMeta('property', 'og:description', page.description);
    setMeta('property', 'og:url', url);
    setMeta('name', 'twitter:title', page.title);
    setMeta('name', 'twitter:description', page.description);
    setCanonical(url);
  }, [pathname]);

  return null;
}
